import { useSchedules } from '../../data/schedule';
import { useAllMedicationsForReminders, useVaccinations } from '../../data/meds';
import { useSettings } from '../../data/settings';
import { reminderFingerprint, type ReminderInput } from '../../lib/ics';
import { localToday } from '../sessions/fields';

/** Everything a reminders file is built from, as of today. */
export function useReminderInput(): { input: ReminderInput; isLoading: boolean } {
  const { current, exceptions, isLoading } = useSchedules();
  const medications = useAllMedicationsForReminders();
  const { vaccinations, isLoading: vaccinationsLoading } = useVaccinations();
  return {
    input: { schedule: current, exceptions, medications, vaccinations, today: localToday() },
    isLoading: isLoading || vaccinationsLoading
  };
}

/** 'none' before the first export; 'stale' once meds, schedule or vaccinations changed since. */
export function useRemindersStatus(): 'none' | 'current' | 'stale' | 'loading' {
  const { settings, isLoading: settingsLoading } = useSettings();
  const { input, isLoading } = useReminderInput();
  const exported = settings.reminders_export;
  if (settingsLoading || isLoading) return 'loading';
  if (!exported) return 'none';
  return reminderFingerprint(input, exported.options, exported.since) === exported.fingerprint ? 'current' : 'stale';
}
